import { render, staticRenderFns } from "./NoteDevicesWidgetComponent.vue?vue&type=template&id=64ef5425&"
import script from "./NoteDevicesWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./NoteDevicesWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports